import api from "@/services/api";

import { VerifyDocumentType } from "@/types/user/VerifyDocument";

class VerifyDocument {
  execute = async (document: string) => {
    const cleanedDocument = document.replace(/\D/g, "");
    const user = await api().post(`/verify-document`, {
      document: cleanedDocument,
    });
    return user.data as VerifyDocumentType;
  };
}

export { VerifyDocument };
